import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mt-6">頁面未找到</h1>
        <p className="mt-2 text-sm text-foreground-500">{location.pathname}</p>
        <p className="mt-4 text-sm text-foreground-600">此頁面不存在或尚未生成</p>
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 mt-6 bg-primary-500 text-background-50 px-5 py-2.5 rounded-md text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
        >
          <i className="ri-home-line"></i>
          返回首頁
        </Link>
      </div>
    </div>
  );
}